import { useEffect, useRef } from 'react';
import QrHole from '@/shared/assets/qr-hole.svg';
import TgIcon from '@/shared/assets/telegram-qr.svg?svg';
import QRCodeStyling from 'qr-code-styling';

import styles from './TelegramModal.module.css';

const getQrOptions = (data: string) => {
  return new QRCodeStyling({
    width: 240,
    height: 240,
    type: 'svg',
    data: data,
    qrOptions: {
      errorCorrectionLevel: 'H',
    },
    dotsOptions: {
      type: 'rounded',
      color: '#000',
    },
    backgroundOptions: {
      color: 'transparent',
    },
    cornersSquareOptions: {
      type: 'extra-rounded',
      color: '#000',
    },
    cornersDotOptions: {
      type: 'rounded',
      color: '#000',
    },
    image: QrHole,
    imageOptions: {
      imageSize: 0.2,
      margin: 0,
    },
  });
};

export const Qr = ({ link }: { link: string }) => {
  const qrRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (qrRef.current) {
      const qrCode = getQrOptions(link);
      qrRef.current.innerHTML = '';
      qrCode.append(qrRef.current);
    }
  }, []);

  return (
    <div className={styles.qr}>
      <div ref={qrRef} />

      <div className={styles.qrIcon}>
        <TgIcon />
      </div>
    </div>
  );
};
